import React from "react";

import img1 from "images/path74.png";
import img2 from "images/path78.png";
import img3 from "images/path92.png";
import img4 from "images/path126.png";

import imgCentral from "images/rabar/_CLO2412.jpeg";

const StoriaRabar = () => {
	return (
		<section className="module" id="alt-features">
			<div className="container">
				<div className="row">
					<div className="col-sm-6 col-md-3 col-lg-3">
						<div className="alt-features-item" style={{ marginTop: 0 }}>
							<div className="alt-features-icon">
								<img src={img1} alt="Icona tappa iniziale del progetto Rabar" />
							</div>
							<h3 className="alt-features-title font-alt">RABAR</h3>Nel cuore del centro, a
							fianco di una lavanderia divenuta ristorante, c’era un fiorista “germogliato“ in
							bar.
						</div>
						<div className="alt-features-item">
							<div className="alt-features-icon">
								<img src={img2} alt="Icona sviluppo e crescita di Rabar nel tempo" />
							</div>
							<h3 className="alt-features-title font-alt">FIORERIA</h3>Mantenendo viva l’anima
							del luogo, RABAR conserva l’essenza della Fioreria con pezzi unici di lampade
							ispirate a piante e fiori in un contesto che vuole legare ancora con il Passato.
						</div>
					</div>
					<div className="col-md-6 col-lg-6 hidden-xs hidden-sm">
						<div className="alt-services-image align-center">
							<img
								src={imgCentral}
								alt="Macchina per preparare il caffè da Rabar"
								style={{ height: 480, objectFit: "none" }}
							/>
						</div>
					</div>
					<div className="col-sm-6 col-md-3 col-lg-3">
						<div className="alt-features-item" style={{ marginTop: 0 }}>
							<div className="alt-features-icon">
								<img src={img3} alt="Icona momenti chiave nella storia di Rabar" />
							</div>
							<h3 className="alt-features-title font-alt">PROPOSTA</h3>La proposta è
							Concentrata nella parte di colazione e, all’accendersi dei “fiori”,
							nell’aperitivo all’italiana, con “manicaretti” - piccola tapas rivisitata - a
							fare da rinforzo alla bevuta.
						</div>
						<div className="alt-features-item">
							<div className="alt-features-icon">
								<img src={img4} alt="Icona traguardi raggiunti da Rabar" />
							</div>
							<h3 className="alt-features-title font-alt">RISULTATO</h3>Dove prima si
							innnaffiavano bulbi, ora si “innaffiano” calici, dove prima si seminavano
							piante, ora germoglia il Conviviale.
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default StoriaRabar;
